/* ExportAction.js */

"use strict";
const _ = require("lodash");

class ExportAction {
    constructor(logger, gameEditor, activeView, steveIo) {
        this._logger = logger;
        this._activeView = activeView;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this.run = this.run.bind(this);
    }
    run() {
        return Promise.resolve().then(() => {
            let result = [];
            let entityId = this._gameEditor.getOsCatalogId();
            if (!_.isEmpty(entityId)) {
                let entity = entityId && this._gameEditor.getOsCatalog();
                if (!_.isEmpty(entity)) {
                    result.push(_.omit(entity.properties, "latestHaveIChanged"));
                }
                this._fileFactory.saveJsonAsFile(
                    JSON.stringify(result),
                    "CatalogExport-" + new Date().toISOString() + ".json"
                );
            }
        });
    }
}
module.exports = ExportAction;

ExportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.activeView",
    "$teve.io",
];

ExportAction.$displayDetails = {
    type: "Action",
    name: "ExportAction",
    icon: "configdrift.export_devices",
    shown: false,
    title: "Export Entry",
    order: 1,
};
